import React from 'react';

import { PostType } from '../types';

interface FeedbackFormContextType {
  thumbState: null | string;
  setThumbState: (value: null | string) => void;
  isUnfolded: boolean;
  isSent: boolean;
  setIsSent: (value: boolean) => void;
  isNoticeOpen: boolean;
  setIsNoticeOpen: (value: boolean) => void;
  entityId: number | undefined;
  entityType: PostType;
  closeAction: () => void;
  openAction: () => void;
}

const defaultValues: FeedbackFormContextType = {
  thumbState: null,
  setThumbState: () => {},
  isUnfolded: false,
  isSent: false,
  setIsSent: () => {},
  isNoticeOpen: false,
  setIsNoticeOpen: () => {},
  entityId: undefined,
  entityType: 'helps',
  closeAction: () => {},
  openAction: () => {},
};

export const FeedbackFormContext =
  React.createContext<FeedbackFormContextType>(defaultValues);

export const useFeedbackFormContext = () =>
  React.useContext(FeedbackFormContext);
